'use strict'

$(function () {
  const $win = $(window);
  const winHeight = $win.height();
  const winWidth = $win.width();
  const mvHeight = $('.brand_mv').height();
  const $brandOnline = $('.brand_online');
  let $animationTarget = $('.effect_target:not(.is_on)');

  // 画像スクロールアニメーション
  const scrollAnimation = () => {
    $animationTarget.each(function () {
      let position = $(this).offset().top;
      let scroll = $win.scrollTop();
      if (scroll > position - winHeight) {
        $(this).addClass('is_on');
      }
    });
  }

  // オンラインバナー
  const handleOnlineBannerDisp = () => {
    let currentPosi = $win.scrollTop();
    let footerHeight = $('.footer').height()
    let pageHeight = $('body').height() - winHeight - footerHeight;
    if (mvHeight < currentPosi && pageHeight > currentPosi) {
      $brandOnline.addClass('is_on');
    } else {
      $brandOnline.removeClass('is_on');
    }
  }

  // ファーストビュー
  $win.on('load', function () {
    scrollAnimation();
  });

  // スクロール時
  $win.on('scroll', function () {
    scrollAnimation();

    if ($brandOnline.length) {
      handleOnlineBannerDisp();
    }
  });

  // スムーズスクロール
  $('a[href^="#"]').click(function () {
    const speed = 400;
    const href = $(this).attr("href");
    const target = $(href == "#" || href == "" ? 'html' : href);
    const position = target.offset().top;
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });


});


$(function () {
  var $elem = $('.js-switch');
  var sp = '_sp.';
  var pc = '_pc.';
  var replaceWidth = 768;

  function imageSwitch() {
    var windowWidth = parseInt(window.innerWidth);

    $elem.each(function () {
      var $this = $(this);
      if (windowWidth >= replaceWidth) {
        $this.attr('src', $this.attr('src').replace(sp, pc));
      } else {
        $this.attr('src', $this.attr('src').replace(pc, sp));
      }
    });
  }
  imageSwitch();

  // 動的なリサイズは操作後0.2秒経ってから処理を実行する。
  var resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      imageSwitch();
    }, 200);
  });
});